import { render, staticRenderFns } from "./text-field-date.vue?vue&type=template&id=4e05be8c&scoped=true"
import script from "./text-field-date.vue?vue&type=script&lang=ts"
export * from "./text-field-date.vue?vue&type=script&lang=ts"
import style0 from "./text-field-date.vue?vue&type=style&index=0&id=4e05be8c&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e05be8c",
  null
  
)

export default component.exports